import { cn } from "@/utils/cn";

const PencomLogo = ({ className }: { className?: string }) => {
  const LOGIN_LOGO = "/assets/images/onboarding/pencom_logo_transparent.png";
  return (
    <div className="flex items-center gap-4 p-6 pt-[47px] pl-[22px]">
      <img
        src={LOGIN_LOGO}
        alt="PenCom"
        className="h-[87px] w-12 object-cover"
        loading="eager"
      />
      <p
        className={cn(
          "font-clash-display font-semibold text-[28px] text-black leading-normal",
          className
        )}
      >
        National Pension Commission
      </p>
    </div>
  );
};

export default PencomLogo;
